import { useMemo } from 'react'
import styles from './info.module.css'

interface Liquid3DProductDetailsProps {
  description: string;
  columnClassName: string;
  bodyRef?: (element: HTMLDivElement | null) => void;
}

const colorSwatches: Record<string, string> = {
  'parrot green': '#a8d600',
  sashimi: '#ff6049',
};

const getFabricColor = (description: string): string => {
  const text = description
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ');

  return text.match(/^Fabric Colou?r:\s*(.+)$/im)?.[1]?.trim() ?? '';
};

export default function Liquid3DProductDetails({
  description,
  columnClassName,
  bodyRef,
}: Liquid3DProductDetailsProps) {
  const fabricColor = useMemo(() => getFabricColor(description), [description]);
  const swatchColor = colorSwatches[fabricColor.toLowerCase()] ?? fabricColor;

  return (
    <div className={[styles.card, columnClassName].join(' ')}>
      <h3 className={styles.title}>Product Details</h3>
      <div className={styles.cardBody} ref={bodyRef}>
        <div className={styles.details}>
          <span className={styles.name}>Service Type:</span>
          <span className={styles.value}>Liquid 3D Emblem®</span>
        </div>
        <div className={styles.details}>
          <span className={styles.name}>Product Type:</span>
          <span className={styles.value}>Liquid 3D® Heat Applied</span>
        </div>
        {fabricColor && (
          <div className={styles.details}>
            <span className={styles.name}>Fabric Color:</span>
            <span
              aria-hidden="true"
              className={styles.liquid3DColourSwatch}
              style={{ backgroundColor: swatchColor }}
            />
            <span className={styles.value}>{fabricColor}</span>
          </div>
        )}
      </div>
    </div>
  );
}
